export default __webpack_public_path__ + "a8d6ac03c7b96b7acb6228ff2676139d.ttf";